import React from 'react';
import './App.css';
import {Outlet, useLocation} from "react-router-dom";
import {useTranslation} from './i18n/LanguageProvider';

export const Navigator = () => {
    const location = useLocation();
    const {t} = useTranslation();
    return (
        <div className={'App'}>
            <nav className={'Navigator-nav'}>
                <a href="https://anonchat.com" className={'Navigator-a'}>
                    {t('nav.home')}
                </a>
                <a href="https://premium.anon.chat" className={`Navigator-a ${location.pathname === '/' && 'active'}`}>
                    {t('nav.checkout')}
                </a>
            </nav>
            <Outlet/>
        </div>
    );
};
